/* Prime Raw — product page helpers: ingredient tabs + "how long a box lasts". */
if (!customElements.get('pr-tabs')) {
  customElements.define(
    'pr-tabs',
    class PrTabs extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.tabs = Array.prototype.slice.call(this.querySelectorAll('[role="tab"]'));
        this.tabs.forEach(function (tab, index) {
          tab.addEventListener('click', function () { self.select(index); });
          tab.addEventListener('keydown', function (event) {
            if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
            var next = (index + (event.key === 'ArrowRight' ? 1 : -1) + self.tabs.length) % self.tabs.length;
            self.select(next);
            self.tabs[next].focus();
          });
        });
        if (this.tabs.length) this.select(0);
      }

      select(index) {
        var self = this;
        this.tabs.forEach(function (tab, i) {
          var on = i === index;
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          tab.tabIndex = on ? 0 : -1;
          var panel = self.querySelector('#' + tab.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      }
    }
  );
}

if (!customElements.get('pr-box-calc')) {
  customElements.define(
    'pr-box-calc',
    class PrBoxCalc extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('input');
        this.days = this.querySelector('[data-days]');
        this.grams = this.querySelector('[data-grams]');
        this.input.addEventListener('input', this.update.bind(this));
        this.update();
      }

      update() {
        var unitsEl = this.querySelector('[data-units]');
        if (unitsEl) unitsEl.textContent = Math.round((parseFloat(this.dataset.boxGrams) || 9080) / 454);
        var kg = parseFloat(this.input.value);
        var pct = parseFloat(this.dataset.percent) || 2.5;
        var box = parseFloat(this.dataset.boxGrams) || 9080;
        if (isNaN(kg) || kg <= 0) {
          this.days.textContent = '–';
          this.grams.textContent = '–';
          return;
        }
        var perDay = Math.round((kg * 1000 * pct) / 100 / 5) * 5;
        this.grams.textContent = perDay;
        this.days.textContent = Math.max(1, Math.floor(box / perDay));
      }
    }
  );
}

/* Appstle Subscriptions inserts its widget inside .product-form__buttons; move it just above so it is full width. */
(function () {
  function place(root) {
    (root || document).querySelectorAll('.appstle_sub_widget').forEach(function (widget) {
      if (widget.dataset.prPlaced) return;
      var buttons = widget.closest('.product-form__buttons');
      widget.dataset.prPlaced = 'true';
      if (buttons) { buttons.parentNode.insertBefore(widget, buttons); }
      widget.parentNode.classList.add('pr-appstle-slot');
    });
  }
  if (!('MutationObserver' in window)) return;
  var mo = new MutationObserver(function () { place(); });
  function start() {
    place();
    document.querySelectorAll('.product-form').forEach(function (form) { mo.observe(form, { childList: true, subtree: true }); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* When the size (variant) changes, refresh blocks that depend on it from Dawn's re-rendered HTML. */
(function () {
  function hook() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var html = event && event.data && event.data.html;
      if (!html) return;
      document.querySelectorAll('[data-pr-variant-sync]').forEach(function (el) {
        var fresh = html.getElementById(el.id);
        if (!fresh) return;
        if (el.tagName === 'PR-BOX-CALC') {
          el.dataset.boxGrams = fresh.dataset.boxGrams;
          if (el.update) el.update();
        } else {
          el.innerHTML = fresh.innerHTML;
        }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hook); else hook();
})();

/* Delivery countdown to the same-day cut-off (UK time). */
if (!customElements.get('pr-delivery')) {
  customElements.define(
    'pr-delivery',
    class PrDelivery extends HTMLElement {
      connectedCallback() {
        this.cutoff = parseInt(this.dataset.cutoff, 10) || 12;
        this.out = this.querySelector('[data-countdown]');
        this.tick = this.tick.bind(this);
        this.tick();
        this.timer = setInterval(this.tick, 30000);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }

      ukMinutes() {
        var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(new Date());
        var get = function (type) { return parseInt(parts.find(function (p) { return p.type === type; }).value, 10); };
        return get('hour') * 60 + get('minute');
      }

      tick() {
        var left = this.cutoff * 60 - this.ukMinutes();
        var label = this.cutoff > 12 ? (this.cutoff - 12) + 'pm' : this.cutoff + (this.cutoff === 12 ? 'pm' : 'am');
        if (left > 0) {
          var h = Math.floor(left / 60);
          var m = left % 60;
          this.out.innerHTML = 'Order within <strong>' + (h ? h + 'h ' : '') + m + 'm</strong> for <strong>same-day delivery</strong>';
          this.classList.add('is-sameday');
        } else {
          this.out.innerHTML = 'Order now for <strong>free next-day delivery</strong> (same-day for orders before ' + label + ')';
          this.classList.remove('is-sameday');
        }
      }
    }
  );
}
